import type { EndpointBuilder } from "@reduxjs/toolkit/query";
import { baseApi } from "../baseApi";

export type StoreFaqItemOut = {
  id: number;
  lang_code: string;
  question: string;
  answer: string;
  sort_order: number;
  metadata_json?: Record<string, unknown> | null;
};

export type StoreFaqListResponse = {
  items: StoreFaqItemOut[];
  total: number;
};

export type StoreListFaqsArgs = {
  lang_code?: string | null;
  fallback_lang_code?: string | null;
  active_only?: boolean;
  limit?: number;
};

type Builder = EndpointBuilder<any, any, any>;

export const storeFaqApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    listStoreFaqs: builder.query<StoreFaqListResponse, StoreListFaqsArgs | void>({
      query: (args) => ({
        url: "/store/faqs",
        method: "GET",
        params: {
          lang_code: args?.lang_code || "en",
          fallback_lang_code: args?.fallback_lang_code || "en",
          active_only: args?.active_only ?? true,
          limit: args?.limit ?? 500,
        },
      }),
      transformResponse: (response: StoreFaqListResponse): StoreFaqListResponse => ({
        items: response?.items ?? [],
        total: response?.total ?? 0,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useListStoreFaqsQuery } = storeFaqApi;
